module.exports = __webpack_public_path__ + "static/media/bill.90658a4c.svg";